export const esCuotaConciliada = cuota => Number(cuota.representante?.idPrincipal ?? 0) !== 0

export const getPrestamoStatus = cuotas => {
  const conciliadas = cuotas.filter(esCuotaConciliada).length
  if (cuotas.length && conciliadas === cuotas.length) return 'Conciliado'
  return conciliadas > 0 ? 'Parcialmente Conciliado' : 'Pendiente'
}
